// Colors
export const WHITE = '#ffffff';
export const BLACK = '#000000';

// Rainbow
export const RAINBOW_RED = '#ff0000';
export const RAINBOW_ORANGE = '#ffa500';
export const RAINBOW_YELLOW = '#ffff00';
export const RAINBOW_GREEN = '#008000';
export const RAINBOW_BLUE = '#0000ff';
export const RAINBOW_INDIGO = '#4b0082';
export const RAINBOW_VIOLET = '#ee82ee';

export const RAINBOW_ORANGE_2 = '#CC8500';
export const RAINBOW_ORANGE_3 = '#806026';

// Trophies
export const GOLD = '#C9B037';
export const SILVER = '#B4B4B4';
export const BRONZE = '#AD8A56';

// Blue
export const BLUE_1 = '#7c8fce';
export const BLUE_2 = '#5a6fb4';
export const BLUE_3 = '#415082';
export const BLUE_4 = '#27314f';
export const BLUE_5 = '#1b2136';

// Purple
export const PURPLE_1 = '#b998be';
export const PURPLE_2 = '#9d6ea4';
export const PURPLE_3 = '#74317e';
export const PURPLE_4 = '#512258';
export const PURPLE_5 = '#35063d';

// Red
export const RED_1 = '#b48d96';
export const RED_2 = '#9b6672';
export const RED_3 = '#824150';
export const RED_4 = '#683440';
export const RED_5 = '#412028';

// Orange
export const ORANGE_1 = '#CF9153';
export const ORANGE_2 = '#C2884E';
export const ORANGE_3 = '#B57F48';
export const ORANGE_4 = '#9C6D3E';
export const ORANGE_5 = '#5C4025';

// Yellow
export const YELLOW_1 = '#E8DF5D';
export const YELLOW_2 = '#DBD358';
export const YELLOW_3 = '#CFC653';
export const YELLOW_4 = '#B5AE48';
export const YELLOW_5 = '#4F4C20';

// Green
export const GREEN_1 = '#96b48d';
export const GREEN_2 = '#729b66';
export const GREEN_3 = '#508241';
export const GREEN_4 = '#406834';
export const GREEN_5 = '#284120';

// Gray
export const GRAY_1 = '#f7f7f7';
export const GRAY_2 = '#dddddd';
export const GRAY_3 = '#8c8c8c';
export const GRAY_4 = '#505659';
export const GRAY_5 = '#454a4d';

// GRIP TAPE
export const GRIP_TAPE_1 = '#333333';

// Highlights
export const GREEN_HIGHLIGHT = '#3de507';

// Primary
export const PRIMARY_1 = BLUE_1;
export const PRIMARY_2 = BLUE_2;
export const PRIMARY_3 = BLUE_3;
export const PRIMARY_4 = BLUE_4;
export const PRIMARY_5 = BLUE_5;
